import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/OrderPlannerDelivery';
import './OrderPlannerDelivery.css';
import { Button, DropdownButton, MenuItem, FormGroup, FormControl, ControlLabel, HelpBlock, Checkbox, Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import ResetOrderPlannerDataButton from '../common/ResetOrderPlannerData';

import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-datepicker/dist/react-datepicker.css";
import { isNullOrUndefined } from 'util';

class OrderPlannerDelivery extends Component {
    constructor(props) {
        super(props);

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handlePOFormChange = this.handlePOFormChange.bind(this);
        this.handleSpecialInstructionsFormChange = this.handleSpecialInstructionsFormChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.setAsQuote = this.setAsQuote.bind(this);
        this.toggleQuote = this.toggleQuote.bind(this);
        this.leavePO = this.leavePO.bind(this);

        this.state = {
            value: isNullOrUndefined(localStorage.getItem('orderPO')) ? '' : localStorage.getItem('orderPO'),
            specialInstructions: isNullOrUndefined(localStorage.getItem('specialInstructions')) ? '' : localStorage.getItem('specialInstructions'),
            uniquePO: this.props.uniquePO === true ? 'Yes' : 'No',
            requirePO: this.props.requirePO === true ? 'Yes' : 'No',
            showQuoteConfirmation: false,
            isSalesQuote: localStorage.getItem('isSalesQuote') ? Boolean(localStorage.getItem('isSalesQuote')) : false,
        };
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');

            return;
        } else if (!localStorage.getItem('orderPlannerContact')) {
            // Delivery information
            window.open('/order-planner-contact', '_self');

            return;
        }

        this.props.history.push('/order-planner-delivery/');

        this.props.queryOrderPlannerDeliveryModes(true);
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    handleDateChange(date) {
        if (date !== null) {
            this.props.selectDeliveryDate(date.toISOString().substring(0, 10));
        }
    }

    leavePO(e) {
        const length = this.state.value.length;

        if (length > 0 && this.state.uniquePO === "Yes") {
            this.props.queryOrderPlannerUniquePO(this.state.value);
        }
    }

    getValidationStatePO() {
        const length = this.state.value.length;

        if (this.state.requirePO === "Yes" && length === 0) {
            console.log('No PO present.');

            return 'error'
        }

        if (this.props.validUniquePO !== true) {
            console.log('Bad PO:', localStorage.getItem('badPO'))

            return 'error';
        }

        return 'success';
    }

    getValidationStateSpecialInstructions() {
        if (isNullOrUndefined(this.state.specialInstructions)) { return 'success'; }

        const length = this.state.specialInstructions.length;
        if (length > 100) {
            alert('Special instructions must be less than 100 characters long.')
            return 'error';
        }

        //else if (length > 5) return 'warning';
        //else if (length > 0) return 'error';

        return 'success';
    }

    handlePOFormChange(e) {
        this.setState({ value: e.target.value.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, '') });

        this.getValidationStatePO();

        localStorage.setItem('orderPO', e.target.value.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, ''));
    }

    handleSpecialInstructionsFormChange(e) {
        if (e.target.value.length <= 100) {
            this.setState({ specialInstructions: e.target.value.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, '') });

            localStorage.setItem('specialInstructions', e.target.value.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, ''))
        } else {
            this.setState({ specialInstructions: e.target.value.substring(0, 99).replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, '') },
                localStorage.setItem('specialInstructions', this.state.specialInstructions.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, ''))
            );
        }
    }

    toggleQuote(e) {
        if (this.state.isSalesQuote === true) {
            this.setState({ isSalesQuote: false });
            localStorage.removeItem('isSalesQuote');
        } else {
            this.setState({ showQuoteConfirmation: true });
        }
    }

    setAsQuote() {
        this.setState({ isSalesQuote: true })
        localStorage.setItem('isSalesQuote', true);
        this.setState({ showQuoteConfirmation: false });
    }

    handleClose() {
        this.setState({ isSalesQuote: false })
        this.setState({ showQuoteConfirmation: false });
        localStorage.removeItem('isSalesQuote');
    }

    onDatepickerRef(el) { if (el && el.input) { el.input.readOnly = true; } }

    render() {
        return (
            <div>
                <h1>2. Order Options</h1>
                
                <form style={{ maxWidth: '500px' }}>
                    <FormGroup
                        controlId="poForm"
                        validationState={this.getValidationStatePO()}
                    >
                        <ControlLabel>PO Number:</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.value}
                            placeholder="Enter PO"
                            onChange={this.handlePOFormChange}
                            onBlur={this.leavePO}
                        />
                        <FormControl.Feedback />
                        <HelpBlock>Unique PO Required: {this.state.uniquePO}</HelpBlock>
                        <HelpBlock>PO Required: {this.state.requirePO}</HelpBlock>
                    </FormGroup>
                </form>

                <form style={{ maxWidth: '600px' }}>
                    <FormGroup
                        controlId="specialInstructions"
                        validationState={this.getValidationStateSpecialInstructions()}
                    >
                        <ControlLabel>Special Instructions:</ControlLabel>
                        <FormControl
                            style={{ resize: 'vertical' }}
                            componentClass="textarea"
                            value={this.state.specialInstructions}
                            placeholder="Special instructions..."
                            onChange={this.handleSpecialInstructionsFormChange}
                        />
                        <FormControl.Feedback />
                    </FormGroup>
                </form>

                {/*<p>Selected delivery mode:</p>*/}
                {/*<DropdownButton*/}
                {/*    id="DeliveryModeButton"*/}
                {/*    title={this.props.selectedDeliveryMode}*/}
                {/*>*/}
                {/*    {this.props.deliveryModes.map(deliveryMode =>*/}
                {/*        <MenuItem*/}
                {/*            key={deliveryMode.Code}*/}
                {/*            onClick={() => {*/}
                {/*                this.props.selectDeliveryMode(deliveryMode);*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            {deliveryMode.Description}*/}
                {/*        </MenuItem>*/}
                {/*    )}*/}
                {/*</DropdownButton>*/}
                {/*<br /> <br />*/}

                {/*<p>Selected delivery date:</p>*/}
                {/*<DatePicker*/}
                {/*    inputProps={{ readOnly: true }}*/}
                {/*    selected={this.props.selectedDeliveryDate}*/}
                {/*    includeDates={this.props.deliveryDates}*/}
                {/*    onChange={this.handleDateChange}*/}
                {/*    withPortal*/}
                {/*    dateFormat="MM-dd-yyyy"*/}
                {/*    ref={el => this.onDatepickerRef(el)}*/}
                {/*/>*/}
                {/*<br />*/}
                <Checkbox checked={this.state.isSalesQuote}
                    onChange={this.toggleQuote}>
                    Sales Quote
                </Checkbox>

                <ResetOrderPlannerDataButton />
                <Button style={{ marginLeft: '15px' }}
                    onClick={() => {
                    window.open('/order-planner-contact', '_self');
                }}>
                    &laquo; Previous
                </Button>

                <Button style={{ marginLeft: '15px' }}
                    onClick={() => {
                    if (this.getValidationStateSpecialInstructions() !== 'success') {
                        alert('Special instructions must be 100 characters or less.');
                        return;
                    }
                    if (this.getValidationStatePO() !== 'success') {
                        alert('You must enter a valid PO.');
                        return;
                    }
                    window.open('/order-planner-products', '_self');
                }}>
                    Next &raquo;
                </Button>

                <Modal show={this.state.showQuoteConfirmation} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Sales Quote Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>Are you sure you want to set this order as a sales quotation?</h4>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.setAsQuote}>Yes</Button>
                        <Button onClick={this.handleClose}>No</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect(
    state => state.orderPlannerDelivery,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(OrderPlannerDelivery);


// WEBPACK FOOTER //
// ./src/components/sales/OrderPlannerDelivery.js